<template>
  <v-app>
    <v-toolbar
      app
      fixed
      clipped-left
    >
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn :to="{ name: 'search' }" title="検索に戻る" replace icon small>
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <form>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs4 md4><v-select v-model="item.level" :items="[0, 1, 2, 3]" label="レベル" data-vv-name="level" required /></v-flex>
            <v-flex xs4 md4><v-select v-model="item.numberOfSyllables" :items="numberOfSyllablesList" label="音節数" data-vv-name="number of syllables" required /></v-flex>
            <v-flex xs4 md4><v-select v-model="item.language" :items="languageList" label="言語" data-vv-name="language" required /></v-flex>
            <v-flex xs12 md4><v-text-field v-model="item.headword" label="見出し語" data-vv-name="headword" required /></v-flex>
            <v-flex xs12 md4><v-text-field v-model="item.hantai" label="繁体字" data-vv-name="hantai" required /></v-flex>
            <v-flex xs12 md4><v-text-field v-model="item.kantai" label="簡体字" data-vv-name="kantai" required /></v-flex>
            <v-flex xs12 md4><v-text-field v-model="item.yomi" label="読み" data-vv-name="yomi" required /></v-flex>
            <v-flex xs12 md4><v-text-field v-model="item.pronunciation" label="発音" data-vv-name="pronunciation" required /></v-flex>
            <v-flex xs12 md12><v-text-field v-model="item.meaning" label="意味" data-vv-name="meaning" required /></v-flex>
            <v-flex v-for="n in syllableIndexes" :key="'numberOfSyllables' + n" xs12 md12>
              <v-layout row wrap>
                <v-flex xs3 md3><v-text-field :value="`第${(syllables[n].index + 1)}音節`" label="音節" readonly /></v-flex>
                <v-flex xs3 md3><v-text-field v-model="syllables[n].consonant" label="声母" data-vv-name="consonant1" required /></v-flex>
                <v-flex xs3 md3><v-text-field v-model="syllables[n].vowel" label="韻母" data-vv-name="vowel1" required /></v-flex>
                <v-flex xs3 md3>
                  <v-select v-model="syllables[n].tone" :items="toneList"
                            item-value="value" item-text="displayText"
                            label="声調" data-vv-name="tone1" required />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="pa-0">
              <v-btn color="primary" large @click="saveWord">保存</v-btn>
              <v-btn v-if="item.wordId > 0" color="error" large @click="deleteWord">この単語を削除</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { API } from '@/lib/API'

export default {
  name: 'WordEditor',
  components: {
  },
  data () {
    return {
      title: '単語編集',
      loading: true,
      item: {
        wordId: 0,
        level: 0,
        headword: '',
        hantai: '',
        kantai: '',
        yomi: '',
        pronunciation: '',
        numberOfSyllables: '',
        meaning: '',
      },
      syllables: [
        { index: 0, consonant: '', vowel: '', tone: '' },
        { index: 1, consonant: '', vowel: '', tone: '' },
      ],
    }
  },
  computed: {
    ...mapState([
      'api',
      'toneList',
      'numberOfSyllablesList',
      'languageList',
      'isEditable',
    ]),
    ...mapGetters([
    ]),
    syllableIndexes() {
      if (!this.item.numberOfSyllables || this.item.numberOfSyllables > 1) return [0, 1]; // 4 音節以上 (null) か 2 音節以上
      return [0]; // 1 音節
    },
  },
  async activated() {
    this.setLoading(true);
    try {
      const word = (await this.api.getWord(this.$route.params.wordId)).data;
      this.item = word;
      if (word.syllables && word.syllables.length >= 1) {
        word.syllables.sort((a, b) => a.index - b.index); // index 順でソート
        this.syllables[0] = word.syllables[0];
        if (word.syllables.length >= 2) {
          this.syllables[1] = word.syllables[1];
        }
      }
    } catch (e) {
      console.log(e);
      alert('読み込みに失敗しました。\n' + e.message);
      this.returnToSearch(true);
    } finally {
      this.setLoading(false);
    }
  },
  deactivated() {
    this.item = {};
  },
  methods: {
    ...mapMutations([
      'setLoading',
    ]),
    ...mapActions([
    ]),
    async saveWord() {
      if (!confirm('変更を保存しますか？')) return;
      this.setLoading(true);
      try {
        await this.api.saveWord(this.item);
        alert('変更を保存しました。');
      } catch (e) {
        console.log(e);
        alert('保存に失敗しました。\n' + e.message);
      } finally {
        this.setLoading(false);
      }
    },
    async deleteWord() {
      if (!confirm('この単語を削除してよろしいですか？この変更は元に戻せません。')) return;
      this.setLoading(true);
      try {
        await this.api.deleteWord(this.item.wordId);
        alert('単語を削除しました。');
        this.returnToSearch(false);
      } catch (e) {
        console.log(e);
        alert('削除に失敗しました。\n' + e.message);
      } finally {
        this.setLoading(false);
      }
    },
    returnToSearch(replace) {
      if (replace) {
        this.$router.replace({ name: 'search' });
      } else {
        this.$router.push({ name: 'search' });
      }
    },
  },
}
</script>

